import { writable } from "svelte/store";

import { AlumnosServicio } from "./api/servicios/alumnos.servicio.js";
import { CarrerasServicio } from "./api/servicios/carreras.servicio.js";
import { MateriasServicio } from "./api/servicios/materias.servicio.js";

const alumnoServicio = new AlumnosServicio();
const carrerasServicio = new CarrerasServicio();
const materiasServicio = new MateriasServicio();

let tokenCargado = false;

const createAlumnos = () => {
    const { subscribe, set } = writable([]);

    const obtenerData = async () => {
        if (tokenCargado) {
            const alumnos = await alumnoServicio.ObtenerAlumnos();

            set(alumnos);
        }
    };
    const agregarData = async alumnoDTO => {
        if (tokenCargado) {
            await alumnoServicio.AgregarAlumno(alumnoDTO);
            await obtenerData();
        }
    };
    const obtenerDataAlumno = async id =>  {
        if (tokenCargado) {
            return alumnoServicio.ObtenerAlumno(id);
        }
    };

    obtenerData();

    return {
        subscribe,
        actualizarDatos: async () => { await obtenerData(); },
        agregar: async alumnoDTO => { await agregarData(alumnoDTO); },
        obtener: async id => { return await obtenerDataAlumno(id); }
    };
};

const createCarrerasBasicas = () => {
    const { subscribe, set } = writable([]);

    const obtenerData = async () => {
        if (tokenCargado) {
            const carreras = await carrerasServicio.ObtenerCarrerasBasicas()
            set(carreras);
        }
    };
    const agregarData = async carreraDTO => {
        if (tokenCargado) {
            await carrerasServicio.AgregarCarrera(carreraDTO)
            await obtenerData();
        }
    };
    const actualizar = async carreraDTO => {
        if (tokenCargado) {
            await carrerasServicio.GuardarCarrera(carreraDTO, carreraDTO.id);
            await obtenerData();
        }
    };
    const borrar = async carreraId => {
        if (tokenCargado) {
            await carrerasServicio.EliminarCarrera(carreraId);
            await obtenerData();
        }
    };

    obtenerData();

    return {
        subscribe,
        actualizarDatos: async () => { await obtenerData(); },
        agregar: async carreraDTO => { await agregarData(carreraDTO); },
        actualizar: async carreraDTO => { await actualizar(carreraDTO); },
        borrar: async carreraId => { await borrar(carreraId); }
    };
};

const createMaterias = () => {
    const { subscribe, set } = writable([]);

    const obtenerData = async () => {
        if (tokenCargado) {
            const materias = await materiasServicio.ObtenerMaterias();
            set(materias);
        }
    }

    const agregar = async materiaDTO => {
        if (tokenCargado) {
            await materiasServicio.AgregarMateria(materiaDTO);
            await obtenerData();
        }
    };

    const actualizar = async materiaDTO => {
        if (tokenCargado) {
            await materiasServicio.GuardarMateria(materiaDTO.id, materiaDTO);
            await obtenerData();
        }
    }

    const borrar = async materiaDTO => {
        if (tokenCargado) {
            await materiasServicio.EliminarMateria(materiaDTO.id, materiaDTO);
            await obtenerData();
        }
    }

    obtenerData();

    return {
        subscribe,
        actualizarDatos: async () => { await obtenerData(); },
        borrar: async materiaDTO => { await borrar(materiaDTO); },
        agregar: async materiaDTO => { await agregar(materiaDTO); },
        actualizar: async materiaDTO => { await actualizar(materiaDTO); }
    };
}

const createToken = () => {
    const token = localStorage.getItem("token") === null ? "" : localStorage.getItem("token");
    const { subscribe, set } = writable(token);
    if (token !== "") {
        tokenCargado = true;
    }

    const establecerToken = (token) => {
        tokenCargado = token !== "";
        set(token);
        localStorage.setItem("token", token);
    };

    return {
        subscribe,
        set: token => { establecerToken(token); }
    };
}

export const mostrarSidebar = writable(true);
export const token = createToken();
export const alumnos = createAlumnos();
export const carrerasBasicas = createCarrerasBasicas();
export const materias = createMaterias();